import { GameCard } from "@pages/casino/components";
import { GameContainer } from "@pages/casino/pages/provider/elements.js";
import React, { memo, useMemo } from "react";

import useController from "./useController";

const MemoizedGameCard = memo(({ game, hasPlayIconAndGameName }) => (
	<GameCard
		key={game.id}
		game={game}
		hasPlayIconAndGameName={hasPlayIconAndGameName}
	/>
));

const GamesGrid = memo(({ games, loadMoreItems, hasPlayIconAndGameName, loading, totalCount }) => {
	const {
		refs: { loader },
		state: { visibleGames, canLoadMore },
	} = useController({ games, totalCount, loading, loadMoreItems });

	const gameCards = useMemo(() => {
		return visibleGames.map((game) => (
			<MemoizedGameCard
				key={game.id}
				game={game}
				hasPlayIconAndGameName={hasPlayIconAndGameName}
			/>
		));
	}, [visibleGames, hasPlayIconAndGameName]);

	return (
		<GameContainer>
			{gameCards}
			{canLoadMore && <div ref={loader} />}
		</GameContainer>
	);
});

export default GamesGrid;
